import PublicLayout from '@/components/layout/PublicLayout'

export default function Terms() {
  return (
    <PublicLayout>
      <div className="flex-1 flex flex-col items-center p-4 py-8 md:py-12">
        <div className="w-full max-w-3xl">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-[var(--text-primary)]">Terms of Service</h1>
            <p className="text-[var(--text-secondary)] mt-2">Last updated: February 2026</p>
          </div>

          <div className="space-y-6 text-[var(--text-secondary)] leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">1. Acceptance of Terms</h2>
              <p>
                By accessing or using SSDL ("Simple, Secure Drink Log"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">2. Service Description</h2>
              <p>
                SSDL is a free, anonymous drink tracking tool. It allows you to log alcoholic drinks, estimate blood alcohol content (BAC), track drinking patterns, and generate reports. The service is provided at no cost and requires no account registration — only a unique passcode.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">3. No Warranty</h2>
              <p>
                The service is provided "as is" and "as available" without any warranties of any kind, either express or implied. We do not guarantee that the service will be uninterrupted, error-free, or that data will be preserved indefinitely. While we take reasonable steps to protect your data (including versioned backups), you use the service at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">4. Not Medical Advice</h2>
              <p>
                SSDL is a self-awareness tool, not a medical device. BAC calculations are mathematical estimates based on the Widmark formula and standard physiological constants. They should not be used to determine fitness to drive, operate machinery, or make any medical or legal decisions.
              </p>
              <p className="mt-2">
                The health risk assessments provided are based on published guidelines (such as NHMRC) and are for informational purposes only. They do not constitute medical diagnosis or advice. If you are concerned about your alcohol consumption, please consult a qualified healthcare professional.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">5. Your Data</h2>
              <p>
                Your data is stored under a unique passcode. You are solely responsible for remembering and safeguarding your passcode. If you lose your passcode and have not registered a backup email for key recovery, your data may be permanently inaccessible.
              </p>
              <p className="mt-2">
                You retain ownership of all data you enter into the service. We do not claim any rights to your data and will not access, analyse, or share it for any purpose beyond providing the service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">6. Acceptable Use</h2>
              <p>
                You agree not to misuse the service, including but not limited to: attempting to access other users' data, overwhelming the service with automated requests, reverse-engineering the system for malicious purposes, or using the service for any unlawful activity.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">7. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, SSDL and its creators shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or data, arising from or related to your use of the service. This includes, without limitation, any decisions made based on BAC calculations, health risk assessments, or other information provided by the service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-2">8. Changes to Terms</h2>
              <p>
                We may update these Terms of Service from time to time. Continued use of the service after changes are posted constitutes acceptance of the updated terms. We encourage you to review this page periodically.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PublicLayout>
  )
}
